<template>
    <v-layout>
        <v-flex xs12>
            <v-flex xs12 lg12>
                <v-carousel>
                    <v-carousel-item
                            v-for="(img,i) in images"
                            :key="i"
                            :src="img.src"
                    ></v-carousel-item>
                </v-carousel>
            </v-flex>
            <v-flex lg12 mt-3>
                <h1 style="text-align: center"><strong>We provide you the best</strong></h1>
                <p style="text-align: center">One-on-One personalized attention</p>
                <p style="text-align: center">A team of experienced professionals</p>
                <p style="text-align: center">Quality service you deserve.</p>
            </v-flex>
            <v-container grid-list-xl>
                <v-layout row wrap align-center>
                    <v-flex xs12 sm12 lg4 v-for="(card, index) in cards" :key=index>
                        <v-card height="450px">
                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">{{ card.title }}</h3>
                                </div>
                            </v-card-title>
                            <v-img v-bind:src="'static/' + card.img" height="185px"></v-img>

                            <v-slide-y-transition>
                                <v-card-text>{{card.content}}</v-card-text>
                            </v-slide-y-transition>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: 'Home',
        data: () => ({
            images: [
                {src: 'static/main/IMG-1480.jpg'},
                {src: 'static/main/IMG-1481.jpg'},
                {src: 'static/main/IMG-1478.JPG'}

            ],
            showCloud: false,
            showConsulting: false,
            showApp: false,
            cards: [{
                title: "One-Stop Service",
                img: "designed_by_expanded_gallery1.jpg",
                content: `Prudent Accounting Service, LLC. provides a wide range of services to individuals and business in variety
                of industries. At Prudent Accounting Services, LLC., we strive to meet each client's specific needs in planning for
                the future and achieving their goals in an ever-changing financial and regulatory environment!`
            }, {
                title: "Our Team",
                img: "designed_by_expanded_gallery2.jpg",
                content: `Our people is our most valuable wealth. The diversity of their backgrounds, experiences and insights is
                fundamental of our collaborative business way. Our professionals are dedicated to understanding your needs and
                solving your problems. To find out more about a specific individual, click on their name below.`
            }, {
                title: "Resources",
                img: "designed_by_expanded_gallery3.jpg",
                content: `Follow us! We will update some very important tax
                information and updates to our clients! Let us help you to deal with the complicated U.S.
                Tax rule and regulations, and harsh governmental policies.`
            }]
        })
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .v-card {
        width: 350px;
        alignment: top;
    }

    .company{
        font-family: Impact, Charcoal, sans-serif;
        /*font-family: 'Tangerine', serif;*/
        font-size: 38px;
        /*text-shadow: 4px 4px 4px #aaa;*/
        text-align: center;
        color: #8e8e8e;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue